import React from "react";
import SiteLayout from "@/components/SiteLayout";
import Hero from "@/sections/Hero";
import Services from "@/sections/Services";
import Testimonials from "@/sections/Testimonials";
import GameGrid from "@/sections/GameGrid";
import Clients from "@/sections/Clients";
import Contact from "@/sections/Contact";

const HomePage = () => (
  <SiteLayout>
    <Hero />
    <Services />
    <GameGrid
      section="clientwork"
      testid="work-section"
      eyebrow="Client Work"
      eyebrowColor="#c8ff2a"
      title='Games we&apos;ve <span style="color:#c8ff2a">built/partnered</span>'
      subtitle="Client projects and co-development work we've been part of."
      emptyText="Client projects coming soon."
    />
    <GameGrid
      section="games"
      testid="games-section"
      eyebrow="Our Games"
      eyebrowColor="#ff2a8f"
      title='Originals <span style="color:#ff2a8f">we love</span>'
      subtitle="Original IPs we publish under our own name."
      emptyText="Our games are launching soon."
    />
    <GameGrid
      section="assets"
      testid="assets-section"
      eyebrow="Unity Asset Store"
      eyebrowColor="#c8ff2a"
      title='Assets we <span style="color:#c8ff2a">publish</span>'
      subtitle="Production-ready tools and kits for developers worldwide."
      emptyText="Assets coming soon."
    />
    <Testimonials />
    <Clients />
    <Contact />
  </SiteLayout>
);

export default HomePage;
